<div class="confirmation-dialog">
  @if (data.showDialogTitle && data.dialogTitle) {
    <h2 mat-dialog-title>{{ data.dialogTitle }}</h2>
  }
  @if (data.showCloseButton) {
    <button 
      mat-icon-button 
      (click)="onClose()" 
      class="confirmation-dialog__close">
      <mat-icon>close</mat-icon>
    </button>
  }

  <mat-dialog-content>
    <p>{{ data.dialogMessage }}</p>
  </mat-dialog-content>

  @if (data.showNegativeButton || data.showPositiveButton) {
    <mat-dialog-actions>
      @if (data.showNegativeButton) {
        <custom-button 
          [text]="data.negativeButtonLabel!" 
          [variant]="data.negativeButtonVariant!" 
          (click)="onNegative()">
        </custom-button>
      }
      @if (data.showPositiveButton) {
        <custom-button 
          [text]="data.positiveButtonLabel!" 
          [variant]="data.positiveButtonVariant!" 
          (click)="onPositive()">
        </custom-button>
      }
    </mat-dialog-actions>
  }
</div>